import { useContext } from 'react';
import context, { Tenant } from './context';

export default function useTenant(): Tenant {
  return useContext(context);
}
